import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DataFilterDisplayService } from '../../interface';
import { ACCOUNT_GROUP_ORIGIN_OPTIONS } from './account-group-origin-options';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class AccountGroupOriginOptionsDisplayService implements DataFilterDisplayService {
  originOptions = ACCOUNT_GROUP_ORIGIN_OPTIONS;
  constructor(private readonly translateService: TranslateService) {}

  getDisplay(value: string[]): Observable<string> {
    if (!value) {
      return of('');
    }

    const firstValue = value && value[0];
    const selectedOption = this.originOptions.find((o) => o.value === firstValue);
    const selectedLabel = this.translateService.instant(selectedOption.label);

    return of(`<b>${selectedLabel}</b>`);
  }
}
